module.exports = __webpack_public_path__ + "static/images/containers/PostbattleScreen/components/BattleList/images/divider-header.96416248.png";


//////////////////
// WEBPACK FOOTER
// ./containers/PostbattleScreen/components/BattleList/images/divider-header.png
// module id = 3210
// module chunks = 11